import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledHeaderContainer = styled.div<any>`
  ${({isSticky, theme}) => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: ${isSticky ? ` 0px 0 13px` : `0 ${theme.size.grid001} 10px`};
  padding-top: 6px;

  @media (min-width: ${Breakpoints.b960}px) {
    margin: ${isSticky ? ` 0px 0 13px` : `0 ${theme.size.grid002} 10px`};
    padding-top: 10px;
  }

  .breadcrumb-wrapper {
    display: block;
    @media (min-width: ${Breakpoints.b560}px) {
      display: ${isSticky ? `block` : `none`};
    }
  }
`}
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 82%;

  @media (min-width: ${Breakpoints.b560}px) {
    width: 40%;
  }

  @media (min-width: ${Breakpoints.b960}px) {
    width: 40%;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    width: 34%;
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    width: 22%;
  }

  @media (min-width: ${Breakpoints.b2560}px) {
    width: 22%;
  }
`;
